const pageTitleSuffix = '| The Zentera Wool Company'

export const addTitleSuffix = (title: string) => `${title} ${pageTitleSuffix}`

export const PAGE_TITLES = {
  HOME: addTitleSuffix('Home'),
  WOOL_SPECIFICATIONS: addTitleSuffix('Wool Specifications'),
  LOGGED_OUT: addTitleSuffix('Logged Out'),
  WOOL_DATA: addTitleSuffix('Wool Data'),
  OFFERS: addTitleSuffix('Offers'),
  RESOURCES: addTitleSuffix('Resources'),
}
